import { BlockComponentFactory } from '../BlockFactory'
import { VideoBlockProps } from './block-props.types'
import { VideoPlayer } from '../../../components/VideoPlayer/VideoPlayer'
import { LabelBlock } from './LabelBlock'
import Flex from 'antd/lib/flex'
import { LABEL_BOLD_FONT_STYLE } from '../../constants'
import { useSignedURL } from '../../../service/hooks/use-signed-url'
import { toCSSSize } from './block-utils'
import styles from './VideoBlock.module.less'

const MIN_WIDTH = 600
const MIN_HEIGHT = 200

export const VideoBlockComponent = BlockComponentFactory.createBlockComponent<VideoBlockProps>(
    props => {
        const {
            src,
            label,
            infoText,
            width,
            height,
            visibility = 'visible',
            style,
            blockId,
        } = props

        const { url: videoURL, isLoading } = useSignedURL(src)

        const outerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) || `${MIN_WIDTH}px`,
            minWidth: MIN_WIDTH,
        }

        const videoContainerStyle: React.CSSProperties = {
            backgroundColor: '#f0f0f0',
            height: toCSSSize(height) || `${MIN_HEIGHT}px`,
            minHeight: MIN_HEIGHT,
            overflow: 'hidden',
        }

        return (
            <div style={outerStyle} className={styles['videoBlock']}>
                <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_BOLD_FONT_STYLE} />
                {videoURL ? (
                    <Flex style={videoContainerStyle} justify="center" align="center">
                        <VideoPlayer url={videoURL} id={blockId} />
                    </Flex>
                ) : (
                    <Flex style={videoContainerStyle} justify="center" align="center">
                        {isLoading ? 'Loading video...' : <VideoPlayer url={''} id={blockId} />}
                    </Flex>
                )}
            </div>
        )
    }
)
